import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { Flex } from 'components/Flex';
import { Hide } from 'components/Hide';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text/Text';
import { SearchContextHeaderData } from 'containers/SearchContextHeader/SearchContextHeaderData';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { Link, LinkText, ResultsCount } from './SearchContextHeader.styled';
import { searchContextHeaderGetUrl } from './searchContextHeaderGetUrl';

type Props = {
  noDivider?: boolean;
  searchContext: SearchContextHeaderData;
};

export function SearchContextHeader({ noDivider, searchContext }: Props) {
  const {
    searchResultsPath,
    previousResult,
    previousResultPageIndex,
    nextResult,
    nextResultPageIndex,
    resultIndex,
    totalResults,
    setPageIndex,
    originatingPathname,
  } = searchContext;

  const nextUrl = searchContextHeaderGetUrl(nextResult || undefined);
  const previousUrl = searchContextHeaderGetUrl(previousResult || undefined);

  const backState = searchResultsPath?.state?.scrollToId
    ? searchResultsPath.state
    : {};

  return (
    <Text
      data-qa-id="search-context-header"
      fontSize="14px"
      color="lightContentGrey"
      letterSpacing=".26px"
    >
      <Flex justifyContent="space-between">
        <Link
          to={searchResultsPath}
          onClick={() =>
            trackClicked('Back To Results', {
              header_position: 'top',
            })
          }
          data-qa-id="search-context-back-to-search"
          state={backState}
        >
          <Icon name="list" size={16} colorName="lightContentGrey" />{' '}
          <Box verticalAlign="middle" display="inline-block">
            {getText('Back to results')}
          </Box>
        </Link>
        <Flex alignItems="center">
          {previousResult ? (
            <Link
              data-qa-id="search-context-previous-result"
              to={previousUrl}
              state={{
                showSearchContext: true,
                originatingPathname,
                orgId:
                  'orgID' in previousResult ? previousResult.orgID : undefined,
                orgUrl:
                  'orgUrl' in previousResult
                    ? previousResult.orgUrl
                    : undefined,
              }}
              onClick={() => {
                trackClicked('Previous Listing', {
                  org_id:
                    'orgID' in previousResult
                      ? previousResult.orgID
                      : undefined,
                  org_type:
                    'orgType' in previousResult
                      ? previousResult.orgType
                      : undefined,
                  result_id: previousResult.objectID,
                  header_position: 'top',
                });

                if (previousResultPageIndex !== null) {
                  setPageIndex(previousResultPageIndex, false);
                }
              }}
            >
              <LinkText text="previous" />
            </Link>
          ) : (
            <LinkText text="previous" />
          )}

          <Hide xs sm>
            <ResultsCount>
              {resultIndex + 1} of {totalResults}
            </ResultsCount>
          </Hide>

          <Hide md lg xl>
            <Box mx="8px">|</Box>
          </Hide>

          {nextResult ? (
            <Link
              data-qa-id="search-context-next-result"
              to={nextUrl}
              state={{
                showSearchContext: true,
                originatingPathname,
                orgId: 'orgID' in nextResult ? nextResult.orgID : undefined,
                orgUrl: 'orgUrl' in nextResult ? nextResult.orgUrl : undefined,
              }}
              onClick={() => {
                trackClicked('Next Listing', {
                  org_id: 'orgID' in nextResult ? nextResult.orgID : undefined,
                  org_type:
                    'orgUrl' in nextResult ? nextResult.orgType : undefined,
                  result_id: nextResult.objectID,
                  header_position: 'top',
                });

                if (nextResultPageIndex !== null) {
                  setPageIndex(nextResultPageIndex, false);
                }
              }}
            >
              <LinkText text="next" />
            </Link>
          ) : (
            <LinkText text="next" />
          )}
        </Flex>
      </Flex>
      {!noDivider && <Divider marginTop={16} marginBottom={16} />}
    </Text>
  );
}
